import { IMessage } from "react-chatbot-kit/build/src/interfaces/IMessages";

type TChatHistory = {
  messages: any[],
  pages: any[]
}

export const remapChatHistory = (chatHistory: TChatHistory) => {
  const {messages, pages} = chatHistory;
  return messages.map((item: any) => {
    const page = pages.find((itm) => item.page === itm.id);

    const message: IMessage = {
      id: item.id,
      loading: false,
      message: item.content,
      type: item.speaker === 'CLIENT' ? 'user' : "bot",
    }

    if (!!page) {
      message.widget = 'chatForm',
      message.payload = {
        message: item, 
        page
      }
    }

    return message;
  })
}

export const createUserMessage = ({value, page}: any) => {
  let chatUserMessage = '';
  let wsUserMessage = '';

  page.elements.forEach((elem: any, key: number) => {
    const itemValue = value[elem.name];
    const label = _getLabel(elem);
    
    if (label && label !== "") {
      chatUserMessage += `${label} : ${itemValue} \n`;
      wsUserMessage += `${label} : ${itemValue} `;
    } else {
      chatUserMessage += `${itemValue} \n`;
      wsUserMessage += `${itemValue} `;
    }
  })

  return [chatUserMessage, wsUserMessage];
}

export   const isEmpty = (values: any) => {
  const result = Object.values(values).find((item) => !item);
  return result;
}


function _getLabel(element: any) {
  let label = element.label || "";

  // if (!label) {
  //   const result = element.values.find((item: any) => item.value == value);
  //   label = result ? result.label : '';
  // }

  return label;
}
 
export const getUserTokenFromPath = () => {
  let token = '';
  const pathname = window.location.pathname;

  if(pathname.includes('/chat/')) {
    token = pathname.split('/chat/')[1];
  }
  
  return token
}
